/**
 * HR app routes.
 * HR lives at /hr with two sub-sections: /hr/employees (HR Management)
 * and /contacts (Address Book, existing).
 */
const hrRoutes = [
  {
    path: "/hr",
    name: "HrHome",
    component: () => import("@/views/hr/HrHome.vue"),
    meta: { requiresAuth: true, app: "hr" },
  },
  {
    path: "/hr/employees",
    name: "HrEmployees",
    component: () => import("@/views/hr/HrEmployeesHome.vue"),
    // "hr" is the grantable code today; "hr-management" is retired but older
    // accounts still hold it (2026-09-10 — an hr-only user was refused here).
    meta: { requiresAuth: true, app: ["hr", "hr-management"] },
  },
  {
    // Daily attendance exceptions + leave balances (Maurizio's sketch, 2026-10-26):
    // Lolita / Iqbal record the day's exceptions; balances per person.
    path: "/hr/attendance",
    name: "HrAttendance",
    component: () => import("@/views/hr/HrAttendance.vue"),
    meta: { requiresAuth: true, app: ["hr", "hr-management"] },
  },
  {
    // Monthly payroll runs (PAYROLL_PLAN.md): Bal (hr-payroll) captures the
    // variable pay amounts; accounting/gl admins post the accrual + WPS payment.
    path: "/hr/payroll",
    name: "HrPayroll",
    component: () => import("@/views/hr/PayrollHome.vue"),
    // Opens for whoever may see salaries (payroll: true — the payroll grant, or a
    // full accounting/gl admin); editing needs the admin role + a full grant.
    meta: { requiresAuth: true, app: ["hr-payroll", "accounting", "gl"], payroll: true },
  },
];

export default hrRoutes;
